export default {
  root: {},
  elevation1: {
    boxShadow: 'inherit'
  }
};
